import { css } from "styled-components";
export default css(["overflow:hidden;border-radius:2px;"]);
//# sourceMappingURL=radius.js.map